import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatSliderModule } from '@angular/material/slider';
import { GooglePlacesAutocompleteDirective } from './directives/google-places-autocomplete/google-places-autocomplete.directive';
import { PhoneMaskDirective } from './directives/phone-mask/phone-mask.directive';
import { ScrollToInvalidControlDirective } from './directives/scroll-to-invalid-control/scroll-to-invalid-control.directive';

@NgModule({
    declarations: [
        GooglePlacesAutocompleteDirective,
        PhoneMaskDirective,
        ScrollToInvalidControlDirective,
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatRadioModule,
        MatSliderModule,
    ],
    exports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatRadioModule,
        MatSliderModule,
        GooglePlacesAutocompleteDirective,
        PhoneMaskDirective,
        ScrollToInvalidControlDirective,
    ],
})
export class SharedModule {}
